import { createFileRoute } from "@tanstack/react-router";
import SoArbeitenWirPage from "@/pages/SoArbeitenWirPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/so-arbeiten-wir")({
  head: () =>
    buildRouteHead({
      title: "So arbeiten wir | Prozesse & Technik | Agentur Harz",
      description:
        "Strukturierte Prozesse und technische Sicherheit in Wernigerode. Erfahren Sie, wie wir mit JIRA, Teams und modernen Standards arbeiten.",
      path: "/so-arbeiten-wir",
      image: "/images/services/hosting-1024.webp",
      imageAlt: "Transparente Prozesse und technische Sicherheit",
      imageWidth: 1024,
      imageHeight: 730,
    }),
  component: SoArbeitenWirPage,
});
